import lang from '../../../Translation/Ladning.json';

const Tunggakan = ({ data = [] }) => {
  const text = lang.Card;

  // 🔹 Calculate total arrears
  const totalArrears = data.reduce((sum, item) => sum + item.arrears, 0);

  // 🔹 Count unique units (avoid duplicates)
  const uniqueUnits = new Set(data.map((item) => item.unitNumber));
  const totalUnits = uniqueUnits.size;

  // 🔹 Group arrears by zone
  const zoneTotals = data.reduce((acc, item) => {
    const zoneKey = item.zone?.toLowerCase() || 'unknown';
    acc[zoneKey] = (acc[zoneKey] || 0) + item.arrears;
    return acc;
  }, {});

  // 🔹 Calculate percentage by zone
  const getZonePercentage = (zone) => {
    const value = zoneTotals[zone] || 0;
    return totalArrears ? ((value / totalArrears) * 100).toFixed(2) : 0;
  };

  // 🔹 Find latest receipt date
  const latestDate =
    data.length > 0
      ? new Date(
          Math.max(...data.map((item) => new Date(item.receiptDate)))
        ).toISOString()
      : null;

  return (
    <div className="p-5 rounded-md border border-sky-500 bg-sky-300 shadow-md">
      <div>
        <h2 className="text-xl mb-3 font-semibold uppercase">
          {text.Total_Arrears}
        </h2>

        <p className="text-lg">
          {text.amount} :
          <span className="text-xl ms-1 font-medium">
            RM {Number(totalArrears).toLocaleString(undefined, { maximumFractionDigits: 2 })}
          </span>
        </p>

        <p className="text-lg">
          {text.number_of_units} :
          <span className="text-xl ms-1 font-medium">
            {Number(totalUnits).toLocaleString()} {text.unit}
          </span>
        </p>
      </div>

      <hr className="my-4 border-gray-600" />

      {/* 🔹 Zone-based arrears percentage */}
      <div className="space-y-2">
        {[1, 2, 3, 4].map((z) => (
          <div key={z} className="flex justify-between items-center">
            <p className="text-lg font-medium">{`Zone ${z}`}</p>
            <p className="text-lg">{getZonePercentage(`zone${z}`)}%</p>
          </div>
        ))}
      </div>

      {/* 🔹 Latest date display */}
      <div className="flex justify-end items-center mt-4">
        <p className="text-sm text-gray-700">
          {text.date}:{" "}
          {latestDate
            ? new Date(latestDate).toLocaleDateString("en-GB")
            : "N/A"}
        </p>
      </div>
    </div>
  );
};

export default Tunggakan;
